import React, { useContext, useEffect, useState } from "react";

import "../../components/customer-panel/customer-panel.scss";

// import "../../components/customer-panel/CustomerOrders";
import CustomerOrders from "../customer-panel/CustomerOrders";

import Profile from "./Profile";
import Transactions from "components/admin-panel/Transaction/Transactions";
import Loader from "utils/Loader";

// import pic from "../../assets/images/profile.png";
import pic from "../../assets/images/icons8-user-96.png";
import { CgProfile } from "react-icons/cg";
import { BsCardChecklist } from "react-icons/bs";
import { BsWallet2 } from "react-icons/bs";
import UserContext from "context/UserContext";
import { Orders } from "../admin-panel/MainPanel.tsx";
import "../admin-panel/admin-panel.scss";
import AdminOrdersContext, {
  AdminOrdersProvider,
} from "../../context/AdminOrdersContext.tsx";
import { connection } from "utils/apiConnection.ts";
import WithAuthentication from "../../Authentication/AuthenticationContext.ts";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
const ProfileBase = () => {
  let hash = useLocation();

  const [activeButton, setActiveButton] = useState(-1);

  const { user, isLoading, setIsLoading, setCustomerOrders } =
    useContext(UserContext);
  const [img, setimg] = useState("");
  const [what, setWhat] = useState([]);
  const { orders, setOrders } = useContext(AdminOrdersContext);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  let auth = useContext(WithAuthentication);
  let result;
  let p = useParams();
  useEffect(() => {
    async function apiHandler() {
      result = await connection("api/get_all_orders", {
        uid: auth.userInfo.id,
      });

      setOrders(result.orders);

      // console.log("result", result);
      // ordersMain = result.data;
      // console.log(ordersMain);
    }
    apiHandler();
  }, [customerOrders]);
  useEffect(() => {
    setIsLoading(false);
    setCustomerOrders(true);
  }, [user]);
  useEffect(() => {
    hash.hash == "#orders" && setActiveButton(2);
  }, []);
  console.log("base", p);
  return (
    <div className="customer-panel d-flex py-4 justify-content-evenly ">
      {isLoading && <Loader></Loader>}
      {/*  کاربردکمه ها حالت موبایل */}
      <div className="d-flex justify-content-center responsive-btns">
        <div class="align-items-start sidebarInfo">
          <div
            class="nav d-flex justify-content-start nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <button
              class={`nav-link nav-link-res side  ${
                hash.hash != "#orders" && "active"
              }`}
              id="v-pills-profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-profile"
              type="button"
              role="tab"
              aria-controls="v-pills-profile"
              aria-selected="true"
              onClick={(e) => {
                setActiveButton(-1);
              }}
            >
              <span
                className={`befor-active ${
                  activeButton === -1 && " selectedBtn-sid"
                }`}
              >
                <CgProfile
                  style={{ color: "#ff4734" }}
                  className={`icon-size  ${
                    activeButton === -1 && "icon-color"
                  }`}
                />
              </span>
              <span
                className={`text-responsive  ${
                  activeButton === -1 && "text-responsive2"
                }`}
                style={{ marginRight: "5px", marginLeft: "5px" }}
              >
                پروفایل
              </span>
            </button>
            <button
              class="nav-link nav-link-res side"
              id="v-pills-finance-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-finance"
              type="button"
              role="tab"
              aria-controls="v-pills-finance"
              aria-selected="false"
              onClick={(e) => {
                setActiveButton(1);
              }}
            >
              <span
                className={`befor-active ${
                  activeButton === 1 && " selectedBtn-sid"
                }`}
              >
                <BsWallet2
                  style={{ color: "#ff4734" }}
                  className={`icon-size  ${activeButton === 1 && "icon-color"}`}
                />
              </span>
              <span
                className={`text-responsive  ${
                  activeButton === 1 && "text-responsive2"
                }`}
                style={{ marginRight: "5px", marginLeft: "5px" }}
              >
                امورمالی
              </span>
            </button>
            <button
              class={`nav-link nav-link-res side  ${
                hash.hash == "#orders" && " active"
              }`}
              id="v-pills-orders-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-orders"
              type="button"
              role="tab"
              aria-controls="v-pills-orders"
              aria-selected="false"
              onClick={(e) => {
                setActiveButton(2);
              }}
            >
              <span
                className={`befor-active ${
                  activeButton === 2 && " selectedBtn-sid"
                }`}
              >
                <BsCardChecklist
                  style={{ color: "#ff4734" }}
                  className={`icon-size  ${activeButton === 2 && "icon-color"}`}
                />
              </span>

              <span
                className={`text-responsive  ${
                  activeButton === 2 && "text-responsive2"
                }`}
                style={{ marginRight: "5px", marginLeft: "5px" }}
              >
                سفارشات{" "}
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="shadow round d-flex flex-column bg-lightgray col-10 col-sm-4 col-md-4  col-lg-3 sid-custom">
        {/*سایدبارپروفایل*/}
        {user.path == "" || user.path == null ? (
          <img className="logo-size align-self-center" src={pic}></img>
        ) : (
          <img
            className="logo-size align-self-center"
            src={
              img === ""
                ? `${"http://sabadi.tatdemo.ir/" + user.path}`
                : `${img}`
            }
          ></img>
        )}
        <div
          style={{
            height: "1px",
            backgroundColor: "#cdcbcc",
            width: "70%",
            marginTop: "15px",
            alignSelf: "center",
          }}
        ></div>
        <div class="align-items-start sidebarInfo">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <button
              class={`nav-link side  ${hash.hash != "#orders" && "active"}`}
              id="v-pills-profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-profile"
              type="button"
              role="tab"
              aria-controls="v-pills-profile"
              aria-selected="true"
              onClick={(e) => {
                setActiveButton(-1);
              }}
            >
              <div className="d-flex justify-content-center">
                <span
                  className={` ${activeButton === -1 && " selectedBtn-sid"}`}
                  style={{
                    // backgroundColor: "#ff4734",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    boxShadow: "-4px 2px 4px 2px rgba(0, 0, 0, 0.16)",
                    marginRight: "-10px",
                    width: "40px",
                    height: "40px",
                  }}
                >
                  <CgProfile
                    style={{ color: "#ff4734" }}
                    className={`icon-size  ${
                      activeButton === -1 && "icon-color"
                    }`}
                  />
                </span>
                <span
                  className="ms-3"
                  style={{ marginRight: "20px", alignSelf: "center" }}
                >
                  پروفایل
                </span>
              </div>
            </button>
            <button
              class="nav-link side"
              id="v-pills-finance-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-finance"
              type="button"
              role="tab"
              aria-controls="v-pills-finance"
              aria-selected="false"
              onClick={(e) => {
                setActiveButton(1);
              }}
            >
              <div className="d-flex justify-content-center">
                <span
                  className={` ${activeButton === 1 && " selectedBtn-sid"}`}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                    boxShadow: "-4px 2px 4px 2px rgba(0, 0, 0, 0.16)",
                    // marginRight: "15px",
                    width: "40px",
                    height: "40px",
                  }}
                >
                  <BsWallet2
                    style={{ color: "#ff4734" }}
                    className={`icon-size  ${
                      activeButton === 1 && "icon-color"
                    }`}
                  />
                </span>
                <span
                  className="ms-3 "
                  style={{ marginRight: "20px", alignSelf: "center" }}
                >
                  امور مالی
                </span>
              </div>
            </button>
            <button
              class={`nav-link side  ${hash.hash == "#orders" && " active"}`}
              id="v-pills-orders-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-orders"
              type="button"
              role="tab"
              aria-controls="v-pills-orders"
              aria-selected="false"
              onClick={(e) => {
                setActiveButton(2);
              }}
            >
              <div className="d-flex justify-content-center">
                <span
                  className={` ${activeButton === 2 && " selectedBtn-sid"}`}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                    boxShadow: "-4px 2px 4px 2px rgba(0, 0, 0, 0.16)",
                    marginRight: "10px",
                    width: "40px",
                    height: "40px",
                  }}
                >
                  <BsCardChecklist
                    style={{ color: "#ff4734" }}
                    className={`icon-size  ${
                      activeButton === 2 && "icon-color"
                    }`}
                  />
                </span>

                <span
                  className="ms-3"
                  style={{ marginRight: "20px", alignSelf: "center" }}
                >
                  سفارشات
                </span>
              </div>
            </button>
            {/* <button
              class="nav-link"
              id="v-pills-settings-tab"
              data-bs-toggle="pill"
              data-bs-target="#v-pills-settings"
              type="button"
              role="tab"
              aria-controls="v-pills-settings"
              aria-selected="false"
            >
              Settings
            </button> */}
          </div>
        </div>
      </div>
      <div className="shadow round bg-lightgray col-10 col-sm-7 col-md-7 col-lg-8">
        {/* {tabStatus.orders && <CustomerOrders />} */}
        <div class="tab-content" id="v-pills-tabContent">
          <div
            class={`tab-pane fade ${hash.hash != "#orders" && "show active"}`}
            id="v-pills-profile"
            role="tabpanel"
            aria-labelledby="v-pills-profile-tab"
          >
            <Profile />
          </div>
          <div
            class="tab-pane fade"
            id="v-pills-finance"
            role="tabpanel"
            aria-labelledby="v-pills-finance-tab"
          >
            <Transactions />
          </div>
          <div
            class={`tab-pane fade ${hash.hash == "#orders" && "show active"}`}
            id="v-pills-orders"
            role="tabpanel"
            aria-labelledby="v-pills-orders-tab"
            style={{
              background: "white",
              margin: "3rem 1rem",
              // width: "70%",
              borderRadius: "12px",
            }}
          >
            <AdminOrdersProvider>
              <Orders pageName="customer" />
            </AdminOrdersProvider>
          </div>
          {/* <div
              class="tab-pane fade"
              id="v-pills-settings"
              role="tabpanel"
              aria-labelledby="v-pills-settings-tab"
            >
              ...
            </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProfileBase;
